import { ImageBrowserState } from './image-browser.reducer';
import { Dayjs } from 'dayjs';

export function getTimelineIndexByDate(timeline: ImageBrowserState['timeline'], date: Dayjs): number {
  let min = Infinity,
    minIndex = 0;
  for (let i = 1; i < timeline.length; i++) {
    const d = Math.abs(date.valueOf() - timeline[i].date.valueOf());
    if (d === 0) return i;
    if (d === 0 || min < d) return minIndex;
    min = d;
    minIndex = i;
  }
  return minIndex;
  // const  timeline.findIndex()
}
